import {
    WIZARD_FIRST,
    WIZARD_INITIALIZED, WIZARD_LAST, WIZARD_NEXT,
    WIZARD_PREV,
    WIZARD_STARTED, WIZARD_STEP_SELECTED,
    WIZARD_STEP_UPDATED,
    WIZARD_STOPPED,
    WIZARD_ON_FINISH,
    WIZARD_RESET_FINISH,
    WIZARD_STEP_ENABLED,
    WIZARD_STEP_DISABLED,
    WIZARD_STEPS_UPDATED
} from "../Constants";
import _ from "lodash";

export default function (state = {}, action) {
    let currentStep;
    let number;
    let totalSteps;
    let stepDisabled;

    switch (action.type) {
    case WIZARD_INITIALIZED:
        return { ...state, [action.payload.name]: action.payload.wizard };

    case WIZARD_STARTED:
        state[action.payload].stopped = false;
        return { ...state };

    case WIZARD_STOPPED:
        state[action.payload].stopped = true;
        return { ...state };

    case WIZARD_STEP_UPDATED:
        state[action.payload.name].currentStep = action.payload.number;
        return { ...state };

    case WIZARD_PREV:
        currentStep = state[action.payload].currentStep;
        number = 1;
        if (currentStep - 1 >= 1) {
            number = currentStep - 1;
        }

        stepDisabled = state[action.payload].steps[number - 1].disabled;

        if (stepDisabled) {
            const availableSteps = _.filter(state[action.payload].steps, step => step.number < currentStep && step.number !== number);

            if (availableSteps.length < 1) {
                number = currentStep;
            } else if (availableSteps.length === 1) {
                number = availableSteps[0].number;
            } else {
                number = _.orderBy(availableSteps, "number", "desc")[0].number;
            }
        }

        state[action.payload].currentStep = number;
        return { ...state };

    case WIZARD_NEXT:
        currentStep = state[action.payload].currentStep;
        totalSteps = state[action.payload].totalSteps;
        number = state[action.payload].totalSteps;
        if (totalSteps >= currentStep + 1) {
            number = currentStep + 1;
        }

        stepDisabled = state[action.payload].steps[number - 1].disabled;

        if (stepDisabled) {
            const availableSteps = _.filter(state[action.payload].steps, step => step.number > currentStep && step.number !== number);

            if (availableSteps.length < 1) {
                number = currentStep;
            } else if (availableSteps.length === 1) {
                number = availableSteps[0].number;
            } else {
                number = _.orderBy(availableSteps, "number")[0].number;
            }
        }

        state[action.payload].currentStep = number;
        return { ...state };

    case WIZARD_FIRST:
        state[action.payload].currentStep = 1;
        return { ...state };

    case WIZARD_LAST:
        totalSteps = state[action.payload].totalSteps;
        state[action.payload].currentStep = totalSteps;
        return { ...state };

    case WIZARD_STEP_SELECTED:
        currentStep = state[action.payload.name].currentStep;
        if (action.payload.step < currentStep) {
            state[action.payload.name].currentStep = action.payload.step;
            return { ...state };
        }
        return state;

    case WIZARD_ON_FINISH:
        state[action.payload].finish = true;
        return { ...state };

    case WIZARD_RESET_FINISH:
        state[action.payload].finish = false;
        return { ...state };

    case WIZARD_STEP_ENABLED:
        state[action.payload.name].steps[action.payload.step - 1].disabled = false;

        return { ...state };

    case WIZARD_STEP_DISABLED:
        state[action.payload.name].steps[action.payload.step - 1].disabled = true;

        return { ...state };

    case WIZARD_STEPS_UPDATED:
        state[action.payload.name].steps = action.payload.steps;

        return { ...state };

    default:
        return state;
    }
}